App.module('BbSearchApp.BbSearch', function(BbSearch, App, Backbone, Marionette, $, _){
    'use strict';

    BbSearch.Controller = Marionette.Controller.extend({
        searchPhrase: function(searchTerm, fuzzy, forSearchPage){
            var self = this;

            this.startSearchTimeout && clearTimeout(this.startSearchTimeout);
            this.searchPageResultDef && this.searchPageResultDef.abort();
            this.searchDef && this.searchDef.abort();

            if(searchTerm) {
                this.startSearchTimeout = window.setTimeout(function () {
                    self.sendSearchRequest(searchTerm, fuzzy, forSearchPage);
                }, 500);
            } else {
                App.trigger('bbsearch:clear_results');
            }
        },
        sendSearchRequest: function(searchTerm, fuzzy, forSearchPage) {
            var self = this,
                _fuzzy = fuzzy ? 1 : 0,
                triggerPrefix = forSearchPage ? ':page' : '';

            App.trigger('bbsearch' + triggerPrefix + ':started', searchTerm);
            searchTerm = searchTerm.trim();
            var results = new App.Entities.PagerEntity();
            results.queryParams.term = searchTerm;
            results.queryParams.fuzzy = _fuzzy;
            results.state.pageSize = (forSearchPage && this.searchPageItemView) ?
                this.searchPageItemView.defaultSearchSize : this.searchItemView.defaultSearchSize;

            var reqObj = results.fetch().done(function(data){
                App.trigger('bbsearch'+triggerPrefix+':checkResponse', data);
                if (data && data.hits && data.hits.hits && data.hits.hits.length > 0){
                    App.trigger('bbsearch' + triggerPrefix + ':finished', results);
                } else {
                    if(!_fuzzy) {
                        self.searchPhrase(searchTerm, 1, forSearchPage);
                    } else {
                        App.trigger('bbsearch' + triggerPrefix + ':noResult');
                    }
                }
            }).fail(function(response){
                if(window.location.pathname.indexOf('search_result') !== -1 && response.statusText !== 'abort') {
                    $('#main').html($('#error_block').html());
                }
                App.trigger('bbsearch' + triggerPrefix + ':error');
            });

            if(forSearchPage) {
                this.searchPageResultDef = reqObj;
            } else {
                this.searchDef = reqObj;
            }
        },
        initialize: function(){
            var self = this;

            this.searchItemView = new BbSearch.SearchForm();
            if(typeof App.BbSearchApp.BbSearch.SearchPageForm !== 'undefined') {
                this.searchPageItemView = new BbSearch.SearchPageForm();
            }

            App.on('bbsearch:break:search', function(){
                self.searchDef && self.searchDef.abort();
            });
            App.on('bbsearch:break:searchPage', function(){
                self.searchPageResultDef && self.searchPageResultDef.abort();
            });
        }
    });
});
